import { MIN_USERNAME_LENGTH, MAX_USERNAME_LENGTH } from '@colonist/consts';
import { HTTPStatus } from './ErrorEnums.ts';
import { ErrorDefault } from './Errors.ts';
(function(ErrorsLeaderboard) {
    class LeaderboardDisabled extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.leaderboardError.title'
            };
            const message = {
                key: 'strings:popups.errors.leaderboardError.leaderboardsDisabled'
            };
            const httpStatus = HTTPStatus.ServiceUnavailable;
            super(title, message, httpStatus);
        }
    }
    ErrorsLeaderboard.LeaderboardDisabled = LeaderboardDisabled;
    class InvalidRankedMode extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.leaderboardError.title'
            };
            const message = {
                key: 'strings:popups.errors.leaderboardError.invalidRankedMode'
            };
            const httpStatus = HTTPStatus.BadRequest;
            super(title, message, httpStatus);
        }
    }
    ErrorsLeaderboard.InvalidRankedMode = InvalidRankedMode;
    class RankingRangeTooBig extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.leaderboardError.title'
            };
            const message = {
                key: 'strings:popups.errors.leaderboardError.rangeTooBig'
            };
            const httpStatus = HTTPStatus.BadRequest;
            super(title, message, httpStatus);
        }
    }
    ErrorsLeaderboard.RankingRangeTooBig = RankingRangeTooBig;
    class PullingData extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.leaderboardError.title'
            };
            const message = {
                key: 'strings:popups.errors.leaderboardError.errorPullingData'
            };
            const httpStatus = HTTPStatus.InternalServerError;
            super(title, message, httpStatus);
        }
    }
    ErrorsLeaderboard.PullingData = PullingData;
    class IncorrectSearchNameLength extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.leaderboardError.title'
            };
            const message = {
                key: 'strings:popups.errors.leaderboardError.invalidUsernameSearchString',
                options: {
                    minUsernameLength: MIN_USERNAME_LENGTH,
                    maxUsernameLength: MAX_USERNAME_LENGTH
                }
            };
            const httpStatus = HTTPStatus.BadRequest;
            super(title, message, httpStatus);
        }
    }
    ErrorsLeaderboard.IncorrectSearchNameLength = IncorrectSearchNameLength;
    class NoSearchFound extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.leaderboardError.title'
            };
            const message = {
                key: 'strings:popups.errors.leaderboardError.noEntriesFound'
            };
            const httpStatus = HTTPStatus.BadRequest;
            super(title, message, httpStatus);
        }
    }
    ErrorsLeaderboard.NoSearchFound = NoSearchFound;
    class NoFriendsForSearch extends ErrorDefault {
        constructor(usernameFragment){
            const title = {
                key: 'strings:popups.errors.leaderboardError.title'
            };
            const message = {
                key: 'strings:popups.errors.leaderboardError.noFriendsWithUsername',
                options: {
                    usernameFragment: usernameFragment
                }
            };
            const httpStatus = HTTPStatus.BadRequest;
            super(title, message, httpStatus);
        }
    }
    ErrorsLeaderboard.NoFriendsForSearch = NoFriendsForSearch;
    class InvalidParameters extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.leaderboardError.title'
            };
            const message = {
                key: 'strings:popups.errors.leaderboardError.invalidApiParameters'
            };
            const httpStatus = HTTPStatus.BadRequest;
            super(title, message, httpStatus);
        }
    }
    ErrorsLeaderboard.InvalidParameters = InvalidParameters;
    class UnknownError extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.leaderboardError.title'
            };
            const message = {
                key: 'strings:popups.errors.leaderboardError.unknownError'
            };
            const httpStatus = HTTPStatus.InternalServerError;
            super(title, message, httpStatus);
        }
    }
    ErrorsLeaderboard.UnknownError = UnknownError;
    class InvalidUrl extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.leaderboardError.title'
            };
            const message = {
                key: 'strings:popups.errors.leaderboardError.invalidUrl'
            };
            const httpStatus = HTTPStatus.BadRequest;
            super(title, message, httpStatus);
        }
    }
    ErrorsLeaderboard.InvalidUrl = InvalidUrl;
})(ErrorsLeaderboard || (ErrorsLeaderboard = {}));
export var ErrorsLeaderboard;
